// src/pages/BlogPage.js
import React from "react";
import { useParams, Navigate } from "react-router-dom";

// 🚀 Production Imports: All 22 Custom Regional Funding Guides mapped cleanly
import SouthAfricaFundingGuide from "./SouthAfricaFundingGuide";
import NigeriaFundingGuide from "./NigeriaFundingGuide";
import KenyaFundingGuide from "./KenyaFundingGuide";
import EgyptFundingGuide from "./EgyptFundingGuide";
import GhanaFundingGuide from "./GhanaFundingGuide";
import MoroccoFundingGuide from "./MoroccoFundingGuide";
import AngolaFundingGuide from "./AngolaFundingGuide";
import RwandaFundingGuide from "./RwandaFundingGuide";
import UgandaFundingGuide from "./UgandaFundingGuide";
import TanzaniaFundingGuide from "./TanzaniaFundingGuide";
import SenegalFundingGuide from "./SenegalFundingGuide";
import ZimbabweFundingGuide from "./ZimbabweFundingGuide";
import NamibiaFundingGuide from "./NamibiaFundingGuide";
import BotswanaFundingGuide from "./BotswanaFundingGuide";
import MozambiqueFundingGuide from "./MozambiqueFundingGuide";
import MaliFundingGuide from "./MaliFundingGuide";
import LibyaFundingGuide from "./LibyaFundingGuide";
import AlgeriaFundingGuide from "./AlgeriaFundingGuide";
import BurundiFundingGuide from "./BurundiFundingGuide";
import LesothoFundingGuide from "./LesothoFundingGuide";
import DRCFundingGuide from "./DRCFundingGuide";
import ZambiaFundingGuide from "./ZambiaFundingGuide";

const BlogPage = () => {
  const { slug } = useParams();

  // Normalize incoming slug string dynamically to prevent token formatting mismatches
  const normalizedSlug = slug ? slug.toLowerCase().trim() : "";

  // Immutable system directory map pairing slug keys to active custom codebases
  const componentMap = {
    "south-africa-funding-guide": <SouthAfricaFundingGuide />,
    "nigeria-funding-guide": <NigeriaFundingGuide />,
    "kenya-funding-guide": <KenyaFundingGuide />,
    "egypt-funding-guide": <EgyptFundingGuide />,
    "ghana-funding-guide": <GhanaFundingGuide />,
    "morocco-funding-guide": <MoroccoFundingGuide />,
    "angola-funding-guide": <AngolaFundingGuide />,
    "rwanda-funding-guide": <RwandaFundingGuide />,
    "uganda-funding-guide": <UgandaFundingGuide />,
    "tanzania-funding-guide": <TanzaniaFundingGuide />,
    "senegal-funding-guide": <SenegalFundingGuide />,
    "zimbabwe-funding-guide": <ZimbabweFundingGuide />,
    "namibia-funding-guide": <NamibiaFundingGuide />,
    "botswana-funding-guide": <BotswanaFundingGuide />,
    "mozambique-funding-guide": <MozambiqueFundingGuide />,
    "mali-funding-guide": <MaliFundingGuide />,
    "libya-funding-guide": <LibyaFundingGuide />,
    "algeria-funding-guide": <AlgeriaFundingGuide />,
    "burundi-funding-guide": <BurundiFundingGuide />,
    "lesotho-funding-guide": <LesothoFundingGuide />,
    "drc-funding-guide": <DRCFundingGuide />,
    "zambia-funding-guide": <ZambiaFundingGuide />
  };

  // 1. If an explicit programmatic layout match is verified, execute the tranche instantly
  if (componentMap[normalizedSlug]) {
    return componentMap[normalizedSlug];
  }

  // 2. Ironclad GSC Optimization Protection: Evade Soft 404 traps by forcing route isolation
  return <Navigate to="/404" replace />;
};

export default BlogPage;
